import { createSelector } from 'reselect';
import { every, has, find, findIndex, map } from 'lodash';

const getSteps = state => state.wizard.steps;
const getActiveStep = state => state.wizard.activeStep;
const getIsCompleting = state => state.wizard.isCompleting;
const getError = state => state.wizard.error;
const getTimer = state => state.wizard.timer;
const getIsResending = state => state.wizard.isResending;
const getAlternative = state => state.wizard.alternativeEmail;
const getIsActivating = state => state.wizard.isActivating;
const getActivated = state => state.wizard.activated;
const getActivationError = state => state.wizard.activationError;
const getActivationCode = state => state.wizard.activationCode;
const getLicenceStatus = state => state.wizard.licenceStatus;

export const getCompleted = state => state.wizard.completed;

export const activeStepSelector = createSelector(
    getActiveStep,
    activeStep => activeStep
);

export const stepsSelector = createSelector(
    getSteps,
    steps => steps
);

export const stepTitlesAndCompletedSelector = createSelector(
    getSteps,
    steps => map(steps, step => ({
        title: step.title,
        Completed: step.Completed,
        AbleToComplete: step.AbleToComplete,
        Optional: step.Optional
    }))
);

export const activeStepTitleSelector = createSelector(
    getSteps,
    getActiveStep,
    (steps, activeStep) => steps[activeStep - 1].title
);

export const activeStepDescriptionSelector = createSelector(
    getSteps,
    getActiveStep,
    (steps, activeStep) => steps[activeStep - 1].description
);

export const activeStepURLSelector = createSelector(
    getSteps,
    getActiveStep,
    (steps, activeStep) => steps[activeStep - 1].url
);

export const isLastStepSelector = createSelector(
    getSteps,
    getActiveStep,
    (steps, activeStep) => activeStep === steps.length
);

export const generalSelector = createSelector(
    getSteps,
    steps => find(steps, ['key', 'general'])
);

export const networkingSelector = createSelector(
    getSteps,
    steps => find(steps, ['key', 'networking'])
);

export const usersSelector = createSelector(
    getSteps,
    steps => find(steps, ['key', 'users'])
);

export const trunksSelector = createSelector(
    getSteps,
    steps => find(steps, ['key', 'trunks'])
);

export const isSummaryActiveStep = createSelector(
    getActiveStep,
    getSteps,
    (activeStep, steps) => findIndex(steps, ['key', 'summary']) !== activeStep - 1
);

export const isCompletingSelector = createSelector(
    getIsCompleting,
    isCompleting => isCompleting
);

export const activeStepKeySelector = createSelector(
    getSteps,
    getActiveStep,
    (steps, activeStep) => steps[activeStep - 1].key
);

export const errorSelector = createSelector(
    getError,
    error => error
);

export const canFinishSelector = createSelector(
    getSteps,
    steps => every(steps, step => !has(step, 'Completed') ? true : step.Completed)
);

export const completedSelector = createSelector(
    getCompleted,
    completed => completed
);

export const timerSelector = createSelector(
    getTimer,
    timer => timer
);

export const isQRActiveStep = createSelector(
    getActiveStep,
    getSteps,
    (activeStep, steps) => findIndex(steps, ['key', 'qr']) === activeStep - 1
);

export const isResendingSelector = createSelector(
    getIsResending,
    isResending => isResending
);

export const alternativeEmailSelector = createSelector(
    getAlternative,
    alternativeEmail => alternativeEmail
);

export const companyEmailSelector = createSelector(
    getSteps,
    steps => find(steps, ['key', 'general']).CompanyEmail
);

export const isActivatingSelector = createSelector(
    getIsActivating,
    isActivating => isActivating
);

export const activatedSelector = createSelector(
    getActivated,
    activated => activated
);

export const activationErrorSelector = createSelector(
    getActivationError,
    activationError => activationError
);

export const activationCodeSelector = createSelector(
    getActivationCode,
    activationCode => activationCode
);

export const licenceStatusSelector = createSelector(
    getLicenceStatus,
    licenceStatus => licenceStatus
);
